export default __webpack_public_path__ + "static/media/137bf214aaa2db8850779b060e92261b.md";